import React, { useState, useEffect, useRef, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import DetailsPageCard from '../../common/DetailsPage/DetailsPageCard';
import CustomModal from '../../../components/common/CustomModal';
import CreateReceiptVoucher from '../CreateForm/CreateReceiptVoucher';
import UpdateReceiptVoucher from '../UpdateForm/UpdateReceiptVoucher';
import MessageBox from '../../common/CustomMessageBox';
import CustomDelete from '../../common/CustomDeleteAlert';
import { LIST_RECEIPT_VOUCHERS_EXPORT, GET_SUPPLIERS_LIST, DELETE_RECEIPT_VOUCHER_EXPORT, LIST_PROFORMA_INVOICES, LIST_COMMERCIAL_INVOICES } from '../../../services/apiRoutes';
import { getCommanImportShipmentId, getCurrencyList, getReceiptType } from '../../../services/CommonServices';
import { genericPost } from '../../../services/authServices';
import ReceiptVoucherView from '../ViewDetails/ReceiptVoucherView';
import { useShipmentDetails } from './useShipmentDetails';
import CustomLoader from '../../common/CustomLoader';
import { AuthContext } from '../../../context/AuthContext';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import { useCompanyDateFormat } from "../../../constants/useCompanyDateFormat";
import axios from 'axios';


const ReceiptVoucher = ({ fetchButtonList }) => {
    const { token } = useContext(AuthContext)
    const companyDateFormat = useCompanyDateFormat();

    const [open, setOpen] = useState(true);
    const [modal, setModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [activeTab, setActiveTab] = useState('Receipt Voucher');
    const [data, setData] = useState([]);
    const [newShippingId, setNewShippingId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [message, setMessage] = useState({ open: false, text: '', type: '' });
    const [receiptVoucherId, setReceiptVoucherId] = useState('');
    const [currencyList, setCurrencyList] = useState([]);
    const [receiptType, setReceiptType] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [viewModal, setViewModal] = useState(false);
    const navigate = useNavigate();
    const { importShipmentId } = useParams();
    const { shipmentDetails, loading: shipmentLoading } = useShipmentDetails(importShipmentId);
    const [deleteAlert, setDeleteAlert] = useState(false)
    const [rowId, setRowId] = useState('')
    const [proformaInvoiceList, setProformaInvoiceList] = useState([]);
    const [commercialInvoiceList, setCommercialInvoiceList] = useState([]);


    let customerId, cifFob;
    const hasFetched = useRef(false);
    useEffect(() => {
        if (shipmentDetails) {
            customerId = shipmentDetails.customerId;
            cifFob = shipmentDetails.cifFob.cifFobName;
            fetchData();
            getCommonData();
            getCustomersList();
            getProformaInvoice();
            fetchDataCommercialList();

            hasFetched.current = true;
        }
    }, [shipmentDetails, updateModal, receiptVoucherId, token, deleteAlert, modal]);
    const fetchDataCommercialList = async () => {
        setLoading(true);
        try {
            const payload = {
                supplierNamesId: customerName,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_COMMERCIAL_INVOICES, payload);

            if (response.data.success) {
                const commercialInvoices = response.data.data.map((invoice, index) => {
                    return {
                        id: invoice.commercialInvoiceId || '',
                        title: invoice.commercialInvoiceNo || '',
                    };
                });
                setCommercialInvoiceList(commercialInvoices);
            } else {
                setError('No commercial invoices found');
            }
        } catch (error) {
            setError('Error fetching commercial invoices');
            console.error('Error fetching commercial invoices', error);
        } finally {
            setLoading(false);
        }
    };

    const getProformaInvoice = async () => {
        try {
            const payload = {
                supplierNamesId: customerName,
                shipmentId: shipmentId
            };
            const response = await genericPost(LIST_PROFORMA_INVOICES, payload, {
            });
            if (response.data && response.data.success && response.data.proformaInvoice) {
                const proform = response.data.proformaInvoice.map((invoice) => ({
                    id: invoice.proformaInvoiceId || '',
                    title: invoice.proformaInvoiceNo || '',
                }));
                setProformaInvoiceList(proform);
            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching suppliers list:', error);
            return [];
        }
    };


    const getCustomersList = async () => {
        try {
            const payload = {
                clientCompanyId: customerId,
            };

            const response = await genericPost(GET_SUPPLIERS_LIST, payload, {
            });

            if (response.data && response.data.success && response.data.clientCompanies) {
                const customersData = response.data.clientCompanies.map((customer) => ({
                    id: customer.clientCompanyId,
                    title: customer.clientCompanyName,
                }));
                setCustomerList(customersData);

            } else {
                return [];
            }
        } catch (error) {
            console.error('Error fetching customer list:', error);
            return [];
        }
    };


    const getCommonData = async () => {
        const currencyListData = await getCurrencyList();
        setCurrencyList(currencyListData);
        const receiptType = await getReceiptType();
        setReceiptType(receiptType);
    }
    const fetchData = async () => {
        setLoading(true);
        try {
            const payload = {
                customerName: customerName,
                commanShipmentId: getCommanImportShipmentId,
                shipmentId: shipmentId

            };
            const response = await genericPost(LIST_RECEIPT_VOUCHERS_EXPORT, payload);

            if (response.data.success) {
                const receiptVouchers = response.data.receiptVouchers.map((voucher, index) => ({
                    index: (index + 1).toString().padStart(2, '0'),
                    receiptVoucherId: voucher.receiptVoucherId || '',
                    userId: voucher.userId || '',
                    companyId: voucher.companyId || '',
                    customerName: voucher.customerName || '',
                    date: companyDateFormat(voucher?.date) || '',
                    receiptVoucherNo: voucher.receiptVoucherNo || '',
                    amount: parseFloat(voucher.amount) || 0,
                    currencyName: voucher.currency?.currency || '',
                    baseCurrencyName: voucher.baseCurrency?.currency || '',
                    baseCurrencyId: voucher.baseCurrencyId || '',
                    note: voucher.note || '',
                    createdAt: voucher.createdAt || '',
                    updatedAt: voucher.updatedAt || '',
                    shipmentIdName: voucher.shipmentId || '',
                    finalAmount: `${voucher?.currency?.currency_symbol || ''} ${voucher.amount || ''}`,
                    conversionRate: `${voucher?.baseCurrency?.currency_symbol || ''} ${parseFloat(voucher.conversionRate)?.toFixed(2) || ''}`,
                    baseAmount: `${voucher?.baseCurrency?.currency_symbol || ''} ${parseFloat(voucher.baseAmount)?.toFixed(2) || ''}`,
                    bankCharges: `${voucher?.baseCurrency?.currency_symbol || ''} ${parseFloat(voucher.bankCharges)?.toFixed(2) || ''}`,

                }));
                const { newShippingId } = response.data;
                setNewShippingId(newShippingId);
                setData(receiptVouchers);
            } else {
                setError('No receipt vouchers found');
            }
        } catch (error) {
            setError('Error fetching receipt vouchers');
            console.error('Error fetching receipt vouchers', error);
        } finally {
            setLoading(false);
        }
    };
    const handleDelete = async (receiptVoucherId) => {
        setLoading(true);
        const authToken = sessionStorage.getItem('accessToken');

        try {
            const response = await axios.delete(DELETE_RECEIPT_VOUCHER_EXPORT(receiptVoucherId), {
                headers: {
                    Authorization: `Bearer ${authToken}`,
                },
            });

            if (response.status === 200) {
                setDeleteAlert(false);
                fetchButtonList();
                setMessage({
                    open: true,
                    text: "deleted successfully",
                    type: "success",
                });
                fetchData();
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);

            if (error.response) {
                if (error.response.status === 409) {
                    setMessage({
                        open: true,
                        text: error.response.data?.error || "Cannot delete Data. Related Shipment exists.",
                        type: "error",
                    });
                } else {
                    setMessage({
                        open: true,
                        text: "An error occurred while deleting the Data.",
                        type: "error",
                    });
                }
            } else {
                console.error("Error deleting Data", error);
                setMessage({
                    open: true,
                    text: "Network error. Please try again later.",
                    type: "error",
                });
            }
        }
    };


    // Table columns
    const columns = [
        {
            accessor: 'index', label: 'SN', id: 'index', styleAccessor: {
                textAlign: 'center', maxWidth: '200px', width: "50px"
            },
        },
        {
            id: 'date', label: 'Date', accessor: 'date', styleAccessor: {
                textAlign: 'center'
            }
        },
        {
            id: 'receiptVoucherNo', label: 'receipt No.', accessor: 'receiptVoucherNo', styleAccessor: {
                textAlign: 'center'
            }
        },

        {
            id: 'currencyName', label: 'currency', accessor: 'currencyName',
        },
        {
            id: 'finalAmount', label: 'Amount', accessor: 'finalAmount', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'baseCurrencyName', label: 'base currency', accessor: 'baseCurrencyName'
        },
        {
            id: 'conversionRate', label: 'Conversion Rate', accessor: 'conversionRate', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'baseAmount', label: 'Amount base currency', accessor: 'baseAmount', styleAccessor: {
                textAlign: 'right',
            },
        },

        {
            id: 'bankCharges', label: 'Bank Charges', accessor: 'bankCharges', styleAccessor: {
                textAlign: 'right',
            },
        },
        {
            id: 'action',
            label: 'Action',
            accessor: 'action',
            Cell: ({ row }) => (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '1px' }}>
                    <IconButton onClick={() => handleViewClick(row.receiptVoucherId)} style={{ marginRight: '1px' }}>
                        <VisibilityIcon style={{ color: '#059212' }} />
                    </IconButton>
                    <IconButton onClick={() => handleUpdateClick(row.receiptVoucherId)} style={{ marginRight: '1px' }}>
                        <ModeEditOutlineOutlinedIcon style={{ color: '#050C9C' }} />
                    </IconButton>
                    <IconButton onClick={() => handleOpenDeleteAlert(row.receiptVoucherId)}>
                        <DeleteOutlineOutlinedIcon style={{ color: '#E4003A' }} />
                    </IconButton>
                </div>
            ),
        },
    ];



    const handleUpdateClick = (id) => {
        setReceiptVoucherId(id);
        setUpdateModal(true);
    };

    const handleOpenDeleteAlert = (rowId) => {
        setDeleteAlert(true)
        setRowId(rowId)
    }

    const handleOpen = () => {
        setModal(true);
    };

    const handleClose = () => {
        setModal(false);
    };

    const handleCloseUpdate = () => {
        setUpdateModal(false);
        setReceiptVoucherId('');
    };
    const handleViewClick = (id) => {
        setReceiptVoucherId(id);
        setViewModal(true);
    };

    const handleCloseView = () => {
        setViewModal(false);
        setReceiptVoucherId('');
    };

    if (!shipmentDetails) {
        return <p> <CustomLoader open={shipmentLoading} /> </p>;
    }
    const companyName = shipmentDetails.supplier.clientCompanyName;
    const phoneNumber = shipmentDetails.supplier.mobile;
    const customerName = shipmentDetails.supplierId;
    const shipmentId = shipmentDetails.shipmentId;
    const shipmentOrgId = shipmentDetails.importShipmentId;

    const baseCurrencySymbol = shipmentDetails?.company?.baseCurrencyData?.currency_symbol ?? '';
    const currencySymbol = shipmentDetails?.currency?.currency_symbol ?? '';
    const baseCurrencyId = shipmentDetails?.company?.baseCurrencyData?.id ?? '';
    const currencyId = shipmentDetails.currencyId;
    const userId = shipmentDetails.userId;
    const companyId = shipmentDetails.companyId;

    return (
        <div>

            <CustomLoader open={loading} />
            <DetailsPageCard
                Icon={ReceiptLongOutlinedIcon}
                columns={columns}
                title="Receipt Voucher"
                buttonTitle="Create Receipt Voucher"
                handleOpen={handleOpen}
                data={data}
                loading={loading}
                error={error}
            />
            <CustomModal open={modal}  >
                <CreateReceiptVoucher
                    fetchData={fetchData}
                    customerList={customerList}
                    currencyList={currencyList}
                    receiptType={receiptType}
                    customerName={customerName}
                    commanShipmentId={getCommanImportShipmentId}
                    setMessage={setMessage}
                    newShippingId={newShippingId}
                    shipmentId={shipmentId}
                    currencyId={currencyId}
                    currencySymbol={currencySymbol}
                    baseCurrencySymbol={baseCurrencySymbol}
                    baseCurrencyId={baseCurrencyId}
                    shipmentOrgId={shipmentOrgId}
                    proformaInvoiceList={proformaInvoiceList}
                    commercialInvoiceList={commercialInvoiceList}
                    fetchButtonList={fetchButtonList}
                    userId={userId}
                    companyId={companyId}
                    handleClose={handleClose} />
            </CustomModal>

            <CustomModal open={updateModal}  >
                <UpdateReceiptVoucher
                    fetchData={fetchData}
                    currencyList={currencyList}
                    receiptType={receiptType}
                    customerList={customerList}
                    setMessage={setMessage}
                    handleClose={handleCloseUpdate}
                    proformaInvoiceList={proformaInvoiceList}
                    receiptVoucherId={receiptVoucherId}
                    commercialInvoiceList={commercialInvoiceList}
                />
            </CustomModal>
            <CustomModal
                modalStyles={{
                    maxHeight: '70vh',
                    top: "10%",
                }}
                open={viewModal} handleClose={handleCloseView}>
                <ReceiptVoucherView
                    fetchData={fetchData}
                    currencyList={currencyList}
                    receiptType={receiptType}
                    customerList={customerList}
                    setMessage={setMessage}
                    handleClose={handleCloseView}
                    receiptVoucherId={receiptVoucherId}
                />
            </CustomModal>

            <MessageBox
                open={message.open}
                onClose={() => setMessage({ ...message, open: false })}
                message={message.text}
                handleClose={() => setMessage({ ...message, open: false })}
                type={message.type}
            />
            <CustomDelete
                handleDelete={handleDelete}
                open={deleteAlert}
                rowId={rowId}
                handleClose={() => setDeleteAlert(false)}
            />
        </div>
    );
};

export default ReceiptVoucher;
